import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { APP_STATUS_LABEL } from '../../Consts/app-status.const';
import { SYSTEM_ROLE_LABEL, SYSTEM_ROLE_RANK, SystemRole } from '../../Enums/system-role.enum';
import { SystemUserResponse } from '../../Interfaces/api/backoffice/user.interface';

export class SystemUser {
  id = '';
  name: string | null = null;
  first_name: string | null = null;
  last_name: string | null = null;
  email: string | null = null;
  system_role: string | null = null;
  app_status: string | null = null;
  created_at: string | null = null;

  constructor(data: Partial<SystemUserResponse> = {}) {
    Object.assign(this, data);
  }

  get fullName(): string {
    const composed = [this.first_name, this.last_name].filter(Boolean).join(' ').trim();

    return this.name || composed || this.email || this.id;
  }

  get systemRole(): SystemRole | null {
    const known = Object.values(SystemRole) as string[];

    return this.system_role !== null && known.includes(this.system_role)
      ? (this.system_role as SystemRole)
      : null;
  }

  get systemRoleLabelKey(): string {
    const role = this.systemRole;

    return role ? SYSTEM_ROLE_LABEL[role] : VALUE_UNRESOLVED;
  }

  get appStatusLabelKey(): string {
    if (this.app_status === null) {
      return VALUE_UNRESOLVED;
    }

    return APP_STATUS_LABEL[this.app_status] || this.app_status;
  }

  get rank(): number {
    const role = this.systemRole;

    return role ? SYSTEM_ROLE_RANK[role] : 0;
  }
}
